import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

// use when assigning string of HTML that contains styles to the innerHtml of a div
// this will keep the style attributes which otherwise get stripped
// Usage
// <div [innherHtml]="html_with_styles | preserveStyles"></div>
@Pipe({
    name: 'preserveStyles',
    standalone: false
})
export class PreserveInlineStylesPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }
    transform(value) {
        // First, strip <script> tags which sanitizer.bypassSecurityTrustHtml doesn't do
        var div = document.createElement('div');
        div.innerHTML = value;
        var scripts = div.getElementsByTagName('script');
        var i = scripts.length;
        while (i--) {
            scripts[i].parentNode.removeChild(scripts[i]);
        }
        value = div.innerHTML;

        // now use sanitizer.bypassSecurityTrustHtml to trust the remaining html which
        // will preserve all style attributes
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }
}
